import { runQuery } from 'src/api/apollo/runQuery';

export async function fetchList({
	query,
	variables = {},
	transformItems,
	addPerPage = false,
}) {
	const res = {};
	const { data, error } = await runQuery({
		query,
		variables,
		fetchPolicy: 'network-only',
	});

	if (error) {
		throw error;
	}

	if (!data) {
		throw new Error('Empty GraphQL response');
	}

	const rootKey = Object.keys(data)[0];
	const root = data[rootKey];
	let items = Array.isArray(root) ? root : (root.items ?? []);

	if (transformItems) {
		items = transformItems(items);
	}

	res.items = items;

	if (root.pagination) {
		res.pagination = addPerPage
			? { ...root.pagination, perPage: variables.limit }
			: root.pagination;
	}

	return res;
}
